import React, { Component } from 'react';

import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';
import SearchBox from './SearchBox.jsx';

class CategoryBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNav: ''
    };
    this.toggleActiveNav = this.toggleActiveNav.bind(this);
    this.onItemClick     = this.onItemClick.bind(this);
  }

  toggleActiveNav(sNav) {
    let sCurrentNav = this.state.activeNav;
    if (sCurrentNav.toString() === sNav.toString()) sNav = '';
    this.setState({activeNav: sNav});
  }

  onItemClick(evt) {
    this.state = { activeNav: '' };
    this.props.dispatch( navigate(evt) );
  }

  render() {
    let aCategories = this.props.categories;
    let aCategoryLinks = aCategories.map(oCategory => {
      let sCatClassname = '';
      if (this.props.activeFilter === 'category' && oCategory.id === this.props.activeFilterResult.id) {
        sCatClassname = "active";
      }
      return (
        <li key={oCategory.id}>
          <a
            className={sCatClassname}
            href={'/catalog/category/' + oCategory.id + '-' + oCategory.url}
            onClick={this.onItemClick}
          >
            {oCategory.name}
          </a>
        </li>
      );
    });

    let aGenres = this.props.genres; // do we need to sort these?

    let aGenreLinks = aGenres.map(oGenre => {
      let sGenreClassname = '';
      if (this.props.activeFilter === 'genre' && oGenre.id === this.props.activeFilterResult.id) {
        sGenreClassname = "active";
      }
      return (
        <li key={oGenre.id}>
          <a
            className={sGenreClassname}
            href={'/catalog/genre/' + oGenre.id + '-' + oGenre.url}
            onClick={this.onItemClick}
          >
            {oGenre.name}
          </a>
        </li>
      );
    });
    /* GIFTSHOP
    let mobileGiftShop = (
      <li className="mobile-gift">
        <a
          className={ "gift-icon" + (this.props.activeFilter === 'giftshop' ? " active"  : "")}
          href={'/catalog/giftshop'}
          onClick={this.onItemClick}
        >
          The Gift Shop
        </a>
      </li>
    );
    let desktopGiftShop = (
      <ul className={"category-nav-main desktop-gift" + ( this.state.activeNav === 'categories' ? " showing" : " hidden" )} >
        <li>
          <a
            className={ "gift-icon" + (this.props.activeFilter === 'giftshop' ? " active"  : "")}
            href={'/catalog/giftshop'}
            onClick={this.onItemClick}
          >
            The Gift Shop
          </a>
        </li>
      </ul>
    );
    */
    let oCategoryBar = (
      <div>
        <div className = "mobile-nav-wrapper">
          <div
            className = {"mobile-nav-toggler left" + ( this.state.activeNav === 'categories' ? " active" : "" )}
            onClick   = {this.toggleActiveNav.bind( this, 'categories' )}
            >
              <div className="arrow down"></div>
              <h6>Categories</h6>
          </div>
          <div
            className = {"mobile-nav-toggler" + ( this.state.activeNav === 'genres' ? " active" : "" )}
            onClick   = {this.toggleActiveNav.bind( this, 'genres' )}
            >
            <div className="arrow down"></div>
            <h6>Browse</h6>
          </div>
        </div>
        <ul className={"category-nav-main" + ( this.state.activeNav === 'categories' ? " showing" : " hidden" ) } >
          {/*  GIFTSHOP this.props.tla === "DVD" ? <div className="hidden" /> : mobileGiftShop */}
          {aCategoryLinks}
        </ul>
        {/* GIFTSHOP this.props.tla === "DVD" ? <div className="hidden" /> : desktopGiftShop */}
        <ul className={"category-nav-main has-sub" + ( this.state.activeNav === 'genres' ? " showing" : " hidden" )}>
          <li className="category-nav-secondary">
            <div>
              Browse
              <div className="arrow down"></div>
            </div>
            <ul>
              {aGenreLinks}
            </ul>
          </li>
        </ul>
        <SearchBox />
      </div>
      );

    return (
      <div className="category-bar">
        {oCategoryBar}
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'tla': state.store.tla,
      'categories': state.store.visibleCategory.map( x => state.maps.get("categoryMap").get(x)),
      'genres'    : state.store.visibleGenre.map( x => state.maps.get("genreMap").get(x)),
      'activeFilter': state.activeFilter,
      'activeFilterResult': state.activeFilterResult,
      'isLoggedIn': state.isLoggedIn
    };
}

export default connect(mapStateToProps)(CategoryBar);




// WEBPACK FOOTER //
// ./src/components/CategoryBar.jsx